import { render } from "./Transaction.vue?vue&type=template&id=4f73588e&ts=true"
import script from "./Transaction.vue?vue&type=script&lang=ts"
export * from "./Transaction.vue?vue&type=script&lang=ts"

import exportComponent from "/home/yudi/khiza/token-vendor/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__